import React from 'react';
import './App.css'
import FormContainer from './container/form-container/form-container.component';

function App() {
  return (
    <div className="App">
      <FormContainer />
    </div>
  );
}

export default App;
